import React, { useEffect, useState } from "react";
import httpClient from "../../../httpClient";
import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import { Route, Routes } from "react-router-dom";
import axios from "axios";
import HRMMenuPage from "./HRMMenuPage";
import DialogSampleTable from "./sample/DialogSampleTable";
import SoundSampleTable from "./sample/SoundSampleTable";
import NoiseSampleTable from "./sample/NoiseSampleTable";
import MemberTable from "./member/MemberTable";
import MemberToManagerTable from "./member/MemberToManagerTable";
import OrgStatusTable from "./member/OrgStatusTable";
import ScriptConfirmStatusTable from "./member/ScriptConfirmStatusTable";
import ScriptConfirmAssignmentTable from "./member/ScriptConfirmAssignmentTable";
import MemberContractTable from "./manage/contract/MemberContractTable";
import MemberAssignmentTable from "./manage/assignment/MemberAssignmentTable";
import api from "../../../API";
import ScriptFileStatusTable from "./manage/script/ScriptFileStatusTable";
import ScriptFileTable from "./manage/script/ScriptFileTable";
import NvScriptTable from "./manage/nvScript/NvScriptTable";
import DialogOrgTable from "./org/DialogOrgTable";
import SttSrtReUploadDialog from "./org/SttSrtReUploadDialog"
import DialogOrgCountStateTable from "./org/DialogOrgCountStateTable"
import FixDataForTtaListDialog from "./manage/fixDataForTta/FixDataForTtaListDialog";


// 페이지당 유저 권한을 체크하여 메뉴와 페이지를 제어
const HRMPage = (props:any) => {
  const dispatch = useDispatch();
  // const userinfo = useSelector((state:any) => state.userInfo.data)
  const nav = useNavigate();

  const [pageRole, setPageRole] = useState("");

  const auth = useSelector((state:any)=> state.userInfo.data)
  const roles = auth.user.roles;
  const email = auth.user.email;

  // const admin_role = auth.user.roles.find((role:any) => ['ADMIN'].includes(role.role));


  const checkPageRole = (datas:any) => {
    console.log('유저 권한 리스트' , datas)
    let adminRole = roles.find((role:any) => role.role === "ADMIN")
    let managerRole = roles.find((role:any) => role.role === "MANAGER")

    let workerDialogRole = roles.find((role:any) => role.role === "WORKER_DIALOG")
    let workerNoiseRole = roles.find((role:any) => role.role === "WORKER_NOISE")
    let workerSoundRole = roles.find((role:any) => role.role === "WORKER_SOUND")

    if(workerDialogRole) {
      setPageRole("WORKER_DIALOG");
    } else if(workerNoiseRole) {
      setPageRole("WORKER_NOISE");
    } else if(workerSoundRole) {
      setPageRole("WORKER_SOUND");
    }

    if((adminRole && managerRole) || adminRole) {
      setPageRole("ADMIN");
    } else if(managerRole) {
      setPageRole("MANAGER");
    }
  }
  
  console.log('pageRole',pageRole)

  // const getAuth = async () => {
  //   api.get('/@me',{params:{email:email}})
  //   .then((resp:any) => {dispatch(setUserInfo(resp.data)) , console.log('관리자 페이지', resp.data) })
  //     // alert("파일 업로드가 완료되었습니다.");
  //   .catch((error:any) => {console.error('에러',error.response);})
  //   // alert("파일 업로드 실패. " + error.response.data.error);
  // }

  useEffect(() => {
    checkPageRole(roles)
  },[roles])

  const open = props.switchPage;
  var control = 'block';
  if(open)
    control = 'none'

  return (
    <Box sx={{display: control, justifyContent: "center", padding:"30px 40px 30px 40px"}}>
        {/* <Paper sx={{ margin: "0px", padding: "16px", borderTop: "4px solid #3e36a5"}}> */}
          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box display="flex">
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "20px", letterSpacing:"-2px"}}>2023 - NKI</Box>
              <Box sx={{marginLeft:"auto", marginRight:"20px", fontWeight:600, fontSize: "16px"}}>{"HOME > NKI > 회원/ID 관리"}</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <Box display="flex" justifyContent="left">
              <Box>
                <HRMMenuPage pageRole={pageRole} />
              </Box>
              <Box sx={{width:"100%"}}>
                <Routes>
                  <React.Fragment>
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_DIALOG") ? 
                    <Route path="dialogSample/*" element={<DialogSampleTable />} />
                    :""}
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_SOUND") ? 
                    <Route path="soundSample/*" element={<SoundSampleTable />} />
                    :""}
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_NOISE") ? 
                    <Route path="noiseSample/*" element={<NoiseSampleTable />} />
                    :""}

                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_DIALOG") ? 
                    <React.Fragment>
                      <Route path="dialogOrg/*" element={<DialogOrgTable />} />
                      <Route path="dialogOrgReUploadSttSrt/*" element={<SttSrtReUploadDialog />} />
                    </React.Fragment>
                    :""}

                    {(pageRole == "ADMIN") ? 
                    <React.Fragment>
                      <Route path="dialogCountState/*" element={<DialogOrgCountStateTable />} />
                    </React.Fragment>
                    :""}


                    {/* {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_SOUND") ? 
                    <Route path="soundSample/*" element={<SoundUploadTable />} />
                    :""}
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_NOISE") ? 
                    <Route path="noiseSample/*" element={<NoiseUploadTable />} />
                    :""} */}
                    
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") ? 
                    <React.Fragment>
                      {/* 대화 작업 할당 */}
                      <Route path="memberAssignment/*" element={<MemberAssignmentTable />} />
                      <Route path="memberContract/*" element={<MemberContractTable />} />
                      {/* 스크립트 - 검토완료 */}
                      <Route path="nvScriptList/*" element={<NvScriptTable />} />

                      <Route path="scriptFileList/*" element={<ScriptFileTable />} />

                      <Route path="fixDataForTta/*" element={<FixDataForTtaListDialog />} />
                      
                    </React.Fragment>
                    : ""}
                    {pageRole == "ADMIN" ? 
                    <React.Fragment>
                      <Route path="workerToManager/*" element={<MemberToManagerTable />} />  
                      <Route path="memberList/*" element={<MemberTable />} />  
                      <Route path="scriptFileStatus/*" element={<ScriptFileStatusTable />} />
                      <Route path="orgStatus/*" element={<OrgStatusTable />} />
                      <Route path="scriptConfirmAssignment/*" element={<ScriptConfirmAssignmentTable />} />
                      <Route path="scriptConfirmStatus/*" element={<ScriptConfirmStatusTable />} />
                    </React.Fragment>
                    : ""}
                  </React.Fragment>
                </Routes>
                {/* <Paper>메뉴 상세 페이지</Paper> */}
              </Box>
            </Box>
          </Box>
        {/* </Paper> */}
    </Box>
  );
};

export default HRMPage;
